<template>
  <!-- Layout con .page-container per coerenza con altre pagine -->
  <main id="create-client-page" class="page-container">
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Form principale -->
    <form
      class="create-client-form"
      @submit.prevent="onUpdateClient"
      novalidate
    >
      <!-- RIGA 1: Nome Cliente, Codice fiscale, Telefono, PEC -->
      <div class="create-client-row row-1">
        <div class="field">
          <label for="client-name">Nome cliente *</label>
          <input
            id="client-name"
            type="text"
            v-model="formData.clientName"
            placeholder="inserisci"
          />
        </div>
        <!-- Codice fiscale -->
        <div class="field">
          <label for="fiscal-code">Codice fiscale *</label>
          <input
            id="fiscal-code"
            type="text"
            v-model="formData.taxCode"
            placeholder="inserisci il codice fiscale..."
          />
        </div>
      </div>
      <div class="create-client-row row-2">
        <!-- Telefono -->
        <div class="field">
          <label for="phone">Telefono *</label>
          <input
            id="phone"
            type="text"
            v-model="formData.phoneNumber"
            placeholder="inserisci il numero di telefono..."
          />
        </div>

        <!-- [sc-48860] recapito + PEC/email larghi quanto un campo: allineati alle altre colonne -->
        <div class="recapito-group">
          <div class="field contact-selector">
            <label>Recapito preferito</label>
            <StatusSelect v-model="contactChoice" :options="contactOptions" />
          </div>

          <div class="field" v-if="contactChoice === 'pec'">
            <small v-if="erroreRecapito" class="help-error">{{
              erroreRecapito
            }}</small>
            <small v-else-if="avvisoPec" class="help-warning">{{
              avvisoPec
            }}</small>
            <label for="pec">PEC</label>
            <input
              id="pec"
              type="email"
              v-model="formData.pec"
              placeholder="inserisci l'indirizzo PEC..."
            />
          </div>

          <div class="field" v-if="contactChoice === 'email'">
            <small v-if="erroreRecapito" class="help-error">{{
              erroreRecapito
            }}</small>
            <label for="email">Email</label>
            <input
              id="email"
              type="email"
              v-model="formData.email"
              placeholder="inserisci l'indirizzo email..."
            />
          </div>
        </div>
      </div>

      <!-- RIGA 2b: indirizzi proposti come consegna nei preventivi [sc-48860] -->
      <div class="create-client-row row-2b">
        <div class="field">
          <label for="residenza">Indirizzo di residenza</label>
          <input
            id="residenza"
            type="text"
            v-model="formData.residenceAddress.address"
            placeholder="Via, civico, città…"
            autocomplete="off"
            @keydown.enter.prevent
          />
        </div>
        <div class="field">
          <label for="cantiere">Indirizzo di cantiere</label>
          <input
            id="cantiere"
            type="text"
            v-model="formData.worksiteAddress.address"
            placeholder="Via, civico, città…"
            autocomplete="off"
            @keydown.enter.prevent
          />
        </div>
      </div>

      <hr />

      <!-- RIGA 3: Ragione Sociale + P.IVA -->
      <div class="create-client-row row-3">
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci"
          />
        </div>
      </div>

      <!-- RIGA 4: Codice univoco + Sede Legale -->
      <div class="create-client-row row-4">
        <div class="field">
          <label for="unique-code">Codice univoco</label>
          <input
            id="unique-code"
            type="text"
            v-model="formData.uniqueCode"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="sede-legale">Sede legale</label>
          <input
            type="text"
            id="sede-legale"
            ref="lhInput"
            v-model="formData.legalHeadquarters.address"
            placeholder="Via, civico, città…"
            autocomplete="off"
            @input="onLHTyping"
            @keydown.enter.prevent
          />
        </div>
      </div>

      <hr />

      <div class="save-button-container">
        <button
          id="create-client-button"
          class="primary-btn"
          type="submit"
          :disabled="!canSave"
          :title="titoloSalva"
        >
          Aggiorna
        </button>
      </div>
    </form>

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import StatusSelect from "@/components/StatusSelect.vue";
import { linkMaps, indirizzoValido } from "@/utilities/indirizzo";
import {
  emailValida,
  pecSospetta,
  obbligatoriCliente,
} from "@/utilities/cliente";

// 👇 accetta sia stringa JSON che oggetto
const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
};

export default {
  name: "EditClientPage",
  components: { StatusSelect },
  beforeRouteLeave(to) {
    if (this.navigationConfirmed || to.name === "login") {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  props: ["clientId"],
  watch: {
    contactChoice(newVal) {
      if (newVal === "pec") this.formData.email = "";
      if (newVal === "email") this.formData.pec = "";
    },
  },
  computed: {
    // [sc-48860] stesse regole della creazione
    mancanti() {
      return obbligatoriCliente(this.formData);
    },
    erroreRecapito() {
      const valore = this.contactChoice
        ? this.formData[this.contactChoice]
        : "";
      if (!valore || emailValida(valore)) return "";
      return this.contactChoice === "pec"
        ? "Formato PEC non valido."
        : "Formato email non valido.";
    },
    avvisoPec() {
      return this.contactChoice === "pec" && pecSospetta(this.formData.pec)
        ? "Il dominio non sembra di una PEC, controlla."
        : "";
    },
    canSave() {
      return (
        this.computeSignature() !== this.originalSig &&
        this.mancanti.length === 0 &&
        !this.erroreRecapito
      );
    },
    titoloSalva() {
      if (this.mancanti.length) return `Compila: ${this.mancanti.join(", ")}`;
      if (this.erroreRecapito) return this.erroreRecapito;
      return this.canSave
        ? "Aggiorna cliente"
        : "Modifica almeno uno dei campi";
    },
  },
  data() {
    return {
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,
      formData: {
        clientName: "",
        taxCode: "",
        phoneNumber: "",
        uniqueCode: "",
        companyName: "",
        vatNumber: "",
        email: "",
        pec: "",
        legalHeadquarters: {
          name: "",
          address: "",
          link: "",
        },
        // [sc-48860] proposti come indirizzo di consegna nei preventivi
        residenceAddress: { address: "" },
        worksiteAddress: { address: "" },
      },
      // tracking dell'indirizzo
      originalSig: "",

      errorMessage: "",
      successMessage: "",
      contactChoice: "",
      contactOptions: [
        { value: "pec", label: "PEC", icon: "fa-shield-halved" },
        { value: "email", label: "Email", icon: "fa-envelope" },
      ],
    };
  },
  methods: {
    goBack() {
      this.pendingNavigation = null;
      this.showBackModal = true;
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        // all'elenco, non alla pagina prima nella cronologia: dopo un
        // ricaricamento era di nuovo questa
        this.$router.push({ name: "customers" });
      }
    },
    ...mapActions(["updateClient"]),

    normalizeForCompare() {
      const f = this.formData || {};
      const H = f.legalHeadquarters || {};
      const hq = {
        address: (H.address || "").trim(),
        placeId: H.placeId || "",
      };

      return {
        clientName: f.clientName || "",
        taxCode: f.taxCode || "",
        phoneNumber: f.phoneNumber || "",
        uniqueCode: f.uniqueCode || "",
        companyName: f.companyName || "",
        vatNumber: f.vatNumber || "",
        pec: f.pec || "",
        email: f.email || "",
        legalHeadquarters: hq,
        residenceAddress: (f.residenceAddress?.address || "").trim(),
        worksiteAddress: (f.worksiteAddress?.address || "").trim(),
      };
    },
    computeSignature() {
      return JSON.stringify(this.normalizeForCompare());
    },
    captureSnapshot() {
      this.originalSig = this.computeSignature();
    },

    /**
     * Recupera i dati dell'cliente da modificare.
     * Viene chiamato appena il componente è montato.
     */
    async fetchClientData() {
      try {
        this.errorMessage = "";
        const response = await this.$axios.get(`client/${this.clientId}`);
        // console.log("client data response: ", response);
        // Adatta il percorso a seconda della tua API
        if (response.status === 200) {
          // Popola i campi con i dati ottenuti
          const clientData = response.data.client;
          this.formData.clientName = clientData.clientName;
          this.formData.taxCode = clientData.taxCode;
          this.formData.phoneNumber = clientData.phoneNumber;
          this.formData.uniqueCode = clientData.uniqueCode;
          this.formData.companyName = clientData.companyName;
          this.formData.vatNumber = clientData.vatNumber;
          this.formData.pec = clientData.pec;
          this.formData.email = clientData.email;
          this.contactChoice = clientData.pec
            ? "pec"
            : clientData.email
            ? "email"
            : "";
          this.formData.legalHeadquarters = asLoc(
            clientData.legalHeadquarters
          ) || {
            name: "",
            address: "",
            link: "",
          };

          this.formData.residenceAddress = {
            address: asLoc(clientData.residenceAddress)?.address || "",
          };
          this.formData.worksiteAddress = {
            address: asLoc(clientData.worksiteAddress)?.address || "",
          };

          this.$nextTick(() => {
            if (
              this.$refs.lhInput &&
              this.formData.legalHeadquarters?.address
            ) {
              this.$refs.lhInput.value =
                this.formData.legalHeadquarters.address;
            }
            this.successMessage = `Dati del cliente con ID:${this.clientId} caricati con successo`;
            this.$toast.success(this.successMessage);
            this.captureSnapshot(); // stato iniziale caricato
          });
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message ||
          "Impossibile caricare i dati del cliente.";
        this.$toast.error(this.errorMessage);
      }
    },

    async onUpdateClient() {
      try {
        this.errorMessage = "";
        this.successMessage = "";
        // Invio da tastiera: il form parte anche col pulsante disabilitato
        if (!this.canSave) {
          this.$toast.error(this.titoloSalva);
          return;
        }

        // Puoi usare un FormData se devi inviare anche file (immagine),
        // altrimenti un JSON semplice se l'API lo consente.
        const payload = {
          clientName: this.formData.clientName,
          taxCode: this.formData.taxCode,
          phoneNumber: this.formData.phoneNumber,
          uniqueCode: this.formData.uniqueCode,
          companyName: this.formData.companyName,
          vatNumber: this.formData.vatNumber,
          email: this.formData.email,
          pec: this.formData.pec,
          // [sc-48860] facoltativa: svuotata diventa null
          legalHeadquarters: indirizzoValido(
            this.formData.legalHeadquarters?.address
          )
            ? this.formData.legalHeadquarters
            : null,
          residenceAddress: this.formData.residenceAddress,
          worksiteAddress: this.formData.worksiteAddress,
        };

        // Esempio di richiesta PATCH
        const response = await this.updateClient({
          clientId: this.clientId,
          payload,
        });

        if (response.status === 200) {
          await this.$store.dispatch("fetchClients");

          this.successMessage =
            response.data?.message || "Cliente aggiornato con successo!";
          this.$toast.success(this.successMessage);

          // redirect alla pagina clients
          setTimeout(() => {
            this.$router.push({ name: "customers" });
          }, 1000);
        }
      } catch (error) {
        // Se arrivi qui, c’è un errore => error.response esiste
        if (error.response?.status === 409 || error.response?.status === 400) {
          // l'API mette il motivo in `message` (es. codice fiscale già usato)
          this.errorMessage =
            error.response.data?.message || "Dati del cliente non validi.";
          this.$toast.error(this.errorMessage);
        } else {
          this.errorMessage =
            error.response?.data?.details ||
            error.response?.data?.error ||
            "Errore durante l'aggiornamento del cliente.";
          this.$toast.error(this.errorMessage);
        }
        this.successMessage = "";
      }
    },

    // ----- PAC utilities (uguali alla pagina Preventivo) -----
    onLHTyping() {
      const H = this.formData.legalHeadquarters || {};
      this.formData.legalHeadquarters = {
        name: "",
        address: H.address || "",
        link: linkMaps(H.address),
      };
    },
  },
  /**
   * Appena montato, recupera i dati dall'API
   */
  mounted() {
    this.$nextTick(() => {
      this.lhInput = this.formData?.legalHeadquarters?.address;
    });
    this.fetchClientData();
  },
};
</script>

<style src="@/css/CreateClientPage.css"></style>
